// Function to set the left position
document.addEventListener("DOMContentLoaded", function () {
  const parent = document.querySelector(".price-range-custom-slider");
  if (!parent) return;

  const rangeS = parent.querySelectorAll("input[type=range]");

  // Assuming you want to set the positions based on the initial values
  const slide1 = parseFloat(rangeS[0].value);
  console.log('slide 1 ', slide1);
  const slide2 = parseFloat(rangeS[1].value);
  const totalRange = rangeS[0].max - rangeS[0].min;
  const percentage1 = ((slide1 - rangeS[0].min) / totalRange) * 100;
  const percentage2 = ((totalRange - slide2) / totalRange) * 100;
  // Call the function to set the left and right positions
  setLeftPosition(percentage1, percentage2);
});

function setLeftPosition(percentage1,percentage2) {
  document.querySelector('.price-range-selected-slider').style.left = percentage1 + '%';
  document.querySelector('.price-range-selected-slider').style.right = percentage2 + '%';
}

function initializePriceRangeSlider() {
  const parent = document.querySelector(".price-range-custom-slider");
  // const selectedSlider = document.querySelector(".price-range-selected-slider");

  if (!parent) return;

  const rangeS = parent.querySelectorAll("input[type=range]");
  const numberS = document.querySelectorAll("price-range input[type=number]");

  rangeS.forEach(function (el, index) {
    el.oninput = function () {
      const slide1 = parseFloat(rangeS[0].value);
      const slide2 = parseFloat(rangeS[1].value);

      // var customSlideVal = document.querySelector('input[name="filter.v.price.gte"]').value;
      // customSlideVal = slide1;
      
      if (slide1 > slide2) {
        [rangeS[0].value, rangeS[1].value] = [slide2, slide1];
      }

      numberS[0].value = rangeS[0].value;
      numberS[1].value = rangeS[1].value;

      // Calculate the percentages
      const totalRange = rangeS[index].max - rangeS[index].min;
      percentage1 = ((slide1 - rangeS[index].min) / totalRange) * 100;
      percentage2 = ((totalRange - slide2) / totalRange) * 100;

      
      // Call the function to set the left position
      setLeftPosition(percentage1,percentage2);
    };
  });

  numberS.forEach(function (el, index) {
    el.oninput = function () {
      const number1 = parseFloat(numberS[0].value);
      const number2 = parseFloat(numberS[1].value);

      if (number1 > number2) {
        [numberS[0].value, numberS[1].value] = [number2, number1];
      }

      rangeS[0].value = numberS[0].value;
      rangeS[1].value = numberS[1].value;

      // Update the percentages
      // const totalRange = rangeS[index].max - rangeS[index].min;
      // percentage1 = ((number1 - rangeS[index].min) / totalRange) * 100;
      // percentage2 = ((number2 - rangeS[index].min) / totalRange) * 100;
      
      // // Call the function to set the left position
      // setLeftPosition(percentage1,percentage2);
    };
  });
}
initializePriceRangeSlider();
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Call the method to initialize the price range slider
    // initializePriceRangeSlider();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderProductCount(html);
        initializePriceRangeSlider(); // Initialize price range slider after rendering
        var minRangeVal = document.querySelector('price-range #Filter-Price-GTE').value;
        var maxRangeVal = document.querySelector('price-range #Filter-Price-LTE').value;
        var customSliderMinVal = document.querySelector('.price-range-custom-slider .slider-min-range').value;
        var customSliderMaxVal = document.querySelector('.price-range-custom-slider .slider-max-range').value;
        $(".price-range-custom-slider .slider-min-range").val(minRangeVal);
        $(".price-range-custom-slider .slider-max-range").val(maxRangeVal);

        // Calculate totalRange outside the function
        let totalRange = customSliderMaxVal - customSliderMinVal;
  
        // Call the function to set the left position
        setLeftPosition(percentage1,percentage2);
        
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderProductCount(html);
    // initializePriceRangeSlider(); // Initialize price range slider after rendering
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    //ishi scripts
    document.getElementsByClassName("collection-product-count")[0].innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementsByClassName("collection-product-count")[0].innerHTML;
    const collectionProductCount1 = document.getElementsByClassName("collection-product-count")[1];
    if (collectionProductCount1) {
      document.getElementsByClassName("collection-product-count")[1].innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementsByClassName("collection-product-count")[1].innerHTML;
    }
    if(document.querySelectorAll("#FacetFiltersFormSidebar").length) {
      if(document.querySelectorAll("#FacetFiltersFormSidebar [type='checkbox']:checked").length) {
      document.querySelector("#FacetFiltersFormSidebar .clear-all").style.display = "inline-block";
      } else {
      document.querySelector("#FacetFiltersFormSidebar .clear-all").style.display = "none";
      }
    }
	setGridLayout();
	setupWishlistButtons();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }	
    //const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const facetsToRender = Array.from(facetDetailsElements);
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    facetsToRender.forEach((element) => {
      //document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      document.querySelector('#main-collection-filters').querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;  
    });

    // console.log(parsedHTML);
    document.querySelector("#FacetFiltersFormSidebar").innerHTML = parsedHTML.querySelector("#FacetFiltersForm").innerHTML;
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }
  
  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    if (target == null) return;
    const countElementSelectors = ['.count-bubble'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);
      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    // console.log('formdata'+new FormData);
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
FacetFiltersForm.setListeners();